<template>
  <div
    v-if="showWarn"
    class="review-card-resolved d-flex"
    :class="isMobile ? 'mt-4' : 'text-body-2 success--text'"
  >
    <div class="review-card-resolved__icon d-flex align-center justify-center flex-shrink-0">
      <span class="ui-icon-hand-shaking" />
    </div>
    <div
      class="review-card-resolved__body text-body-2"
      :class="{ 'd-flex align-center ga-2': !isMobile }"
    >
      {{ tStatic('Пациент отметил, что клиника решила проблему') }}
      <v-menu
        attach=""
        offset-y
        :z-index="isMobile ? 110 : 5"
        :open-on-hover="!isMobile"
        :max-width="isMobile ? 320 : 360"
        :nudge-left="isMobile ? undefined : 56"
      >
        <template #activator="{ on, attrs }">
          <button
            v-bind="attrs"
            type="button"
            class="review-card-resolved__hint link-decoration-underline success--text button-reset"
            :class="{ 'text-body-2': !isMobile }"
            v-on="on"
          >
            {{ tStatic('Подробнее') }}
          </button>
        </template>
        <v-card
          class="pa-4 text-body-2"
          elevation="0"
        >
          {{ hintText }}
        </v-card>
      </v-menu>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { Rate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'

const props = defineProps<{
  rate: Rate
}>()

const isMobile = useIsMobile()

const showWarn = computed(() => Boolean(props.rate.resolved && !props.rate.is_deleted))
const hintText = tStatic('Клиника связалась с автором отзыва и исправила ситуацию. Он подтвердил, что описанную проблему решили. Оценка больше не влияет на рейтинг.')
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.review-card-resolved {
  background-color: $ui-kit-bg-success;
  border-radius: $border-radius-sm;
  overflow: hidden;

  &__icon {
    flex: 0 0 40px;
    padding: 8px 0;
    background-color: $ui-kit-success;
    color: $ui-kit-bg-gray-0;
  }

  &__body {
    flex: 1 1 auto;
    padding: 8px 16px;
  }
}
</style>
